/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_EmptyInputs */



/**
* | output |
* | --- |
* | "No entries yet. Stock intakes, assignments and event distributions show up here." |
*
* @param {Promo_Ledger_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_empty = /** @type {((inputs?: Promo_Ledger_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune entrée. Les entrées de stock, attributions et distributions en tournoi apparaissent ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay movimientos. Aquí aparecen las entradas de stock, asignaciones y repartos en torneos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum movimento ainda. Entradas de estoque, atribuições e distribuições em torneios aparecem aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ancora nessun movimento. Qui compaiono entrate di stock, assegnazioni e distribuzioni ai tornei.")
	return /** @type {LocalizedString} */ ("No entries yet. Stock intakes, assignments and event distributions show up here.")
});